import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PurchaseSection from "@/components/Package/PurchaseSection";
import { useAuthStore } from "@/lib/auth/AuthStore";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import React from "react";
import { isBooksProduct } from "src/api/booksProducts";
import { PriceSection } from "../components/PriceSection";
import { ProductDetailContent } from "../components/ProductDetail/ProductDetailContent";
import ProductDetailInfo from "../components/ProductDetail/ProductDetailInfo";
import ProductPreviewModal from "../components/ProductPreviewModal";
import { ProductDetailViewWrapper } from "../styles/ProductDetail.style";
export const ProductDetailView = (param)=>{
    let { product  } = param;
    const { width  } = useWindowDimensions();
    const productType = isBooksProduct(product) ? product.productType : product.source_type;
    const isMobile = width < 768;
    const { isLoggedIn , user: { hasUsableFreepass  }  } = useAuthStore();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(ProductDetailViewWrapper, {
            children: [
                /*#__PURE__*/ _jsx(ProductDetailInfo, {
                    product: product,
                    priceSection: productType === "handout" ? /*#__PURE__*/ _jsx(PurchaseSection, {
                        product: product,
                        hasUsableFreepass: hasUsableFreepass,
                        isLoggedIn: isLoggedIn
                    }) : /*#__PURE__*/ _jsx(PriceSection, {
                        product: product
                    })
                }),
                /*#__PURE__*/ _jsx(ProductDetailContent, {
                    product: product,
                    priceSection: productType === "handout" ? /*#__PURE__*/ _jsx(PurchaseSection, {
                        product: product,
                        hasUsableFreepass: hasUsableFreepass,
                        isLoggedIn: isLoggedIn
                    }) : /*#__PURE__*/ _jsx(PriceSection, {
                        product: product,
                        type: "side"
                    })
                }),
                !isBooksProduct(product) && !isMobile && /*#__PURE__*/ _jsx(ProductPreviewModal, {
                    product: product
                })
            ]
        })
    });
};
